import { Attribute } from 'json-api';
import { LocalizedRange } from 'src/app/shared/time-tools/timezone-select/localizedRange';
import { AtomResource } from '../../core/classes/atom-resource';
import { DateRange } from '../../shared/date-range/date-range';
import { Constructor } from './constructor.type';

export interface ValidableResource extends AtomResource {
  validity?: DateRange | LocalizedRange;
}

export type HasValidity = Constructor<ValidableResource>;

export function Validable<T extends Constructor<AtomResource>>(
  Base: T
): HasValidity & T {
  class ValidableClass extends Base {
    @Attribute({
      convert: (value: string) => new DateRange(value),
      revert: (value: DateRange) => value.toString(),
    })
    validity?: DateRange;
  }
  return ValidableClass;
}
